import React from 'react';
import './footer.component.scss';

const FooterComponent = () => {
    return (
        <div className="site-footer">
            © {new Date().getFullYear().toString()} IntelliSpatial All Rights Reserved |{' '}
            <a
                href="https://intellispatial.io/privacy-policy/"
                target="_blank">
                Privacy Policy
            </a>
        </div>
    );
};

export default FooterComponent;
